import { useContext, useState } from "react";
import { IoClose } from "react-icons/io5";

import InputField from "components/input-field/input-field.component";

import { TicketsContext } from "src/contexts/tickets.context";
import { AuthContext } from "src/contexts/auth.context";

import useTranslate from "src/hooks/use-translate";

import "./new-ticket-modal.style.scss";
import RichTextEditor from "../richt-text-editor/rich-text-editor.component";

const NewTicketModal = ({ dismiss = () => {} }) => {
	const {
		user: { type },
	} = useContext(AuthContext);
	const { createTicket } = useContext(TicketsContext);

	const [subject, setSubject] = useState("");

	const t = useTranslate("NewTicketModal");

	const handleSave = (text) => {
		createTicket(subject, text);
	};

	return (
		<div className="new-ticket-modal-container absolute fill">
			<div onClick={dismiss} className="absolute fill" />
			<div className="modal flex flex--column smooth-corners padding-xxl--inline padding-xxl--block">
				<div className="flex flex--space-between-content border--bottom border--thick border--red padding-s--bottom margin-l--bottom">
					<p className="size500 w600">{t("New Ticket")}</p>
					<IoClose onClick={dismiss} className="pointer" size={"1.6rem"} />
				</div>
				{type === 0 && (
					<div className="flex margin-xxl--bottom gap-s">
						<p className="w500">{t("Assigned To")}</p>
						<p className="w600 red">|</p>
					</div>
				)}
				<div className="flex margin-xxl--bottom gap-s">
					<p className="w500">{t("Subject")}</p>
					<p className="w600 red">|</p>
					<InputField
						className="size400 flex--grow"
						style={{ paddingTop: 0 }}
						fieldType="invisible"
						placeholder={t("Type the topic you want support from your accountant...")}
						value={subject}
						onChange={({ target: { value } }) => setSubject(value)}
					/>
				</div>
				<RichTextEditor dismiss={dismiss} save={handleSave} />
			</div>
		</div>
	);
};

export default NewTicketModal;
